import { render, staticRenderFns } from "./RecycleRequests.html?vue&type=template&id=3b166f26&scoped=true&external"
import script from "./RecycleRequests.js?vue&type=script&lang=js&external"
export * from "./RecycleRequests.js?vue&type=script&lang=js&external"
import style0 from "./RecycleRequests.vue?vue&type=style&index=0&id=3b166f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b166f26",
  null
  
)

export default component.exports